export default {
    cn: {
        mt4SummaryReport: {
            timeText: '交易时间：',
            downloadName: 'MT4总结报表',
            loadText: '正在下载,请稍候...',
            tableHead: [
                { key: 'LOGIN', value: '账号' },
                { key: 'NAME', value: '姓名' },
                { key: 'CURRENCY', value: '入金货币' },
                { key: 'IB_ID', value: '代理账号' },
                { key: 'OFFICE_NAME', value: '所属办事处' },
                { key: 'OID', value: '办事处号码' },
                { key: 'ACC_NAME', value: '所属地区' },
                { key: 'RID', value: '地区编号' },
                { key: 'GROUP', value: '组别' },
                { key: 'DEPOSIT', value: '总入金' },
                { key: 'WITHDRAWL', value: '总出金' },
                { key: 'INOUT', value: '总收入' },
                { key: 'CREDIT', value: '总信贷' },
                { key: 'VOLUME', value: '总手数' },
                { key: 'COMMISSION', value: '总佣金' },
                { key: 'TAXES', value: '总税费' },
                { key: 'AGENT', value: '总代理佣金' },
                { key: 'SWAPS', value: '总库存费' },
                { key: 'PROFIT', value: '总盈亏' },
                { key: 'BALANCE', value: '当前余额' },
            ]
        }
    },
    hk: {
        mt4SummaryReport: {
            timeText: '交易時間：',
            downloadName: 'MT4總結報表',
            loadText: '正在下載,請稍候...',
            tableHead: [
                { key: 'LOGIN', value: '賬號' },
                { key: 'NAME', value: '姓名' },
                { key: 'CURRENCY', value: '入金貨幣' },
                { key: 'IB_ID', value: '代理賬號' },
                { key: 'OFFICE_NAME', value: '所屬辦事處' },
                { key: 'OID', value: '辦事處號碼' },
                { key: 'ACC_NAME', value: '所屬地區' },
                { key: 'RID', value: '地區編號' },
                { key: 'GROUP', value: '組別' },
                { key: 'DEPOSIT', value: '總入金' },
                { key: 'WITHDRAWL', value: '總出金' },
                { key: 'INOUT', value: '總收入' },
                { key: 'CREDIT', value: '總信貸' },
                { key: 'VOLUME', value: '總手數' },
                { key: 'COMMISSION', value: '總佣金' },
                { key: 'TAXES', value: '總稅費' },
                { key: 'AGENT', value: '總代理佣金' },
                { key: 'SWAPS', value: '總庫存費' },
                { key: 'PROFIT', value: '總盈虧' },
                { key: 'BALANCE', value: '當前餘額' }
            ]
        }
    },
    en: {
        mt4SummaryReport: {
            timeText: 'Trade Time：',
            downloadName: 'MT4 Summary Report',
            loadText: 'Downloading now,please wait a moment...',
            tableHead: [
                { key: 'LOGIN', value: 'Login' },
                { key: 'NAME', value: 'Name' },
                { key: 'CURRENCY', value: 'Currency' },
                { key: 'IB_ID', value: 'IB Account' },
                { key: 'OFFICE_NAME', value: 'Office Name' },
                { key: 'OID', value: 'Office ID' },
                { key: 'ACC_NAME', value: 'Region Name' },
                { key: 'RID', value: 'Region ID' },
                { key: 'GROUP', value: 'Group' },
                { key: 'DEPOSIT', value: 'Deposit' },
                { key: 'WITHDRAWL', value: 'Withdrawl' },
                { key: 'INOUT', value: 'In/Out' },
                { key: 'CREDIT', value: 'Credit' },
                { key: 'VOLUME', value: 'Volume' },
                { key: 'COMMISSION', value: 'Commission' },
                { key: 'TAXES', value: 'Taxes' },
                { key: 'AGENT', value: 'Agent' },
                { key: 'SWAPS', value: 'Storage' },
                { key: 'PROFIT', value: 'Profit' },
                { key: 'BALANCE', value: 'Last Balance' }
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/manager-report/mt4SummaryReport.js